import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['section', 'tab', 'tabs'];
  static values = {
    currentSection: { type: Number, default: 1 }
  }

  initialize() {
    this.isLoading = true;
  }

  currentSectionValueChanged(activeTabValue) {
    this.sectionTargets.forEach(section => {
      const sectionId = parseInt(section.dataset.sectionId);
      if (activeTabValue === sectionId) {
        section.classList.remove('hidden');
      } else {
        section.classList.add('hidden');
      }
    });

    this.tabTargets.forEach(tab => {
      const sectionId = parseInt(tab.dataset.sectionId);
      if (activeTabValue === sectionId) {
        tab.classList.add('border-b-4', 'border-[#FBE268]', 'font-bold');
        if (!this.isLoading) {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      } else {
        tab.classList.remove('border-b-4', 'border-[#FBE268]', 'font-bold');
      }
    });

    if (this.hasTabsTarget && !this.isLoading) {
      this.tabsTarget.scrollIntoView({ behavior: 'smooth' });
    }

    if (!this.isLoading) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  connect() {
    this.isLoading = false;
  }

  setActiveSection(e) {
    const selectedSection = parseInt(e.currentTarget.dataset.sectionId);
    this.currentSectionValue = selectedSection;
  }

  next() {
    this.currentSectionValue = Math.min(this.tabTargets.length, this.currentSectionValue + 1);
  }

  previous() {
    this.currentSectionValue = Math.max(1, this.currentSectionValue - 1);
  }
}
